import React from 'react';
import { Box } from '@chakra-ui/react';

interface SparkBarProps {
  values: (number | undefined)[];
  peakIndex?: number;
  height?: number;
  width?: number;
}

/**
 * Sparkline a barre per Cell Rendering Spark (Addendum v2 Parte 17.3).
 * Altezza relativa al max settimanale dell'atleta.
 * Picco settimanale = barra viola con ★, riposo = barra grigia bassa.
 */
export const SparkBar: React.FC<SparkBarProps> = ({
  values,
  peakIndex,
  height = 28,
  width = 84,
}) => {
  const definedValues = values.filter(
    (v): v is number => v !== undefined,
  );
  const max = definedValues.length > 0 ? Math.max(...definedValues) : 0;
  const barWidth = Math.max(4, Math.floor((width - 6) / values.length));
  const gap = 1;

  return (
    <Box
      display="inline-flex"
      alignItems="flex-end"
      height={`${height}px`}
      width={`${width}px`}
      gap={`${gap}px`}
      bg="#fafaf7"
      borderRadius="4px"
      px="2px"
      py="1px"
    >
      {values.map((v, i) => {
        if (v === undefined) {
          return (
            <Box
              key={i}
              width={`${barWidth}px`}
              height="3px"
              bg="#cbd5e1"
              borderRadius="1px"
              opacity={0.5}
            />
          );
        }
        const isPeak = i === peakIndex;
        const ratio = max > 0 ? v / max : 0;
        const h = Math.max(3, Math.floor(ratio * (height - 4)));
        return (
          <Box
            key={i}
            width={`${barWidth}px`}
            height={`${h}px`}
            bg={isPeak ? '#6d28d9' : '#0F6E56'}
            borderRadius="1px"
            position="relative"
            title={String(v)}
          >
            {isPeak && (
              <Box
                position="absolute"
                top="-9px"
                left="50%"
                transform="translateX(-50%)"
                color="#6d28d9"
                fontSize="9px"
                lineHeight="1"
              >
                ★
              </Box>
            )}
          </Box>
        );
      })}
    </Box>
  );
};
